import { Box } from "@mui/material";
import { useJobDetailsContext } from "../../contexts/JobDetailsContext";
import { JobFilesSection } from "./JobFilesSection";
import { JobResultsSection } from "./JobResultsSection";
import { JobTimelineSection } from "./JobTimelineSection";

export function ClientJobDetailsView() {
  const {
    job,
    uploadedFileItems,
    processingArtifactItems,
    isLoadingProcessingResults,
    processingResultsError,
    processingArtifactsRef,
    fileActions,
    onUploadClick,
    getProcessingResultFileUrl,
    onSubmitSuccess,
    onSubmitError,
  } = useJobDetailsContext();

  if (!job) return null;
  return (
    <Box sx={{ flex: 1, overflow: "auto" }}>
      <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: 3 }}>
        {/* Files Section */}
        <JobFilesSection
          job={job}
          context="client"
          uploadedFileItems={uploadedFileItems}
          onUploadClick={onUploadClick}
          onFileDownload={fileActions.handleDownload}
          onFilePreview={(file, index, files) =>
            fileActions.handlePreview(file, files, index)
          }
          onFileDelete={(file) => fileActions.handleDelete(file, "uploaded")}
          onSubmitSuccess={onSubmitSuccess}
          onSubmitError={onSubmitError}
        />

        {/* Timeline Section */}
        <JobTimelineSection job={job} context="client" />

        {/* Results Section - client view (no delete/upload capabilities) */}
        <JobResultsSection
          job={job}
          context="client"
          processingArtifactItems={processingArtifactItems}
          isLoadingProcessingResults={isLoadingProcessingResults}
          processingResultsError={processingResultsError}
          processingArtifactsRef={processingArtifactsRef}
          onUploadClick={() => {
            // For client context, this would be disabled or hidden
            processingArtifactsRef.current?.triggerUpload();
          }}
          onArtifactDownload={fileActions.handleDownload}
          onArtifactPreview={(file, index, files) =>
            fileActions.handlePreview(file, files, index)
          }
          onArtifactDelete={undefined} // Client cannot delete artifacts
          onProcessingResultUpload={undefined} // Client cannot upload processing results
          getProcessingResultFileUrl={getProcessingResultFileUrl}
          uploadedFileItems={uploadedFileItems}
        />
      </Box>
    </Box>
  );
}
